(() => {
  const widget = document.getElementById('PTCQuoteWidget');
  if (!widget) return;

  const key = 'ptc-rental-quote-v1';
  const panel = widget.querySelector('[data-ptc-panel]');
  const overlay = widget.querySelector('[data-ptc-overlay]');
  const openButton = widget.querySelector('[data-ptc-open]');
  const closeButton = widget.querySelector('[data-ptc-close]');
  const count = widget.querySelector('[data-ptc-count]');
  const notice = widget.querySelector('[data-ptc-notice]');
  const list = widget.querySelector('[data-ptc-items]');
  const empty = widget.querySelector('[data-ptc-empty-message]');
  const form = widget.querySelector('form');
  const submit = widget.querySelector('[data-ptc-submit]');
  let items = [];
  let lastFocus = null;
  let noticeTimer;

  try {
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) {
      items = saved.filter((item) => item && item.id && item.title && item.url && Number.isInteger(item.quantity) && item.quantity > 0);
    }
  } catch (_) {
    items = [];
  }

  const save = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); } catch (_) {}
  };

  const render = () => {
    const total = items.reduce((sum, item) => sum + item.quantity, 0);
    count.textContent = String(total);
    openButton.hidden = total === 0;
    empty.hidden = total !== 0;
    form.hidden = total === 0 && !widget.querySelector('[data-ptc-success]');
    submit.disabled = total === 0;
    list.replaceChildren();

    items.forEach((item) => {
      const row = document.createElement('li');
      const link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      row.append(link);

      const controls = document.createElement('div');
      controls.className = 'ptc-quote-items__controls';
      const decrease = document.createElement('button');
      decrease.type = 'button';
      decrease.dataset.ptcQuantity = '-1';
      decrease.dataset.ptcId = item.id;
      decrease.setAttribute('aria-label', '- ' + item.title);
      decrease.textContent = '−';
      const amount = document.createElement('span');
      amount.textContent = String(item.quantity);
      const increase = document.createElement('button');
      increase.type = 'button';
      increase.dataset.ptcQuantity = '1';
      increase.dataset.ptcId = item.id;
      increase.setAttribute('aria-label', '+ ' + item.title);
      increase.textContent = '+';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.ptcRemove = item.id;
      remove.textContent = widget.dataset.ptcRemove;
      controls.append(decrease, amount, increase, remove);
      row.append(controls);
      list.append(row);
    });
  };

  const show = () => {
    notice.hidden = true;
    clearTimeout(noticeTimer);
    lastFocus = document.activeElement;
    overlay.hidden = false;
    panel.hidden = false;
    document.body.classList.add('ptc-quote-open');
    closeButton.focus();
  };

  const hide = () => {
    overlay.hidden = true;
    panel.hidden = true;
    document.body.classList.remove('ptc-quote-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  document.addEventListener('click', (event) => {
    const add = event.target.closest('[data-ptc-add-quote]');
    if (!add) return;
    const id = add.dataset.ptcProductId;
    const existing = items.find((item) => item.id === id);
    if (existing) {
      existing.quantity += 1;
    } else {
      items.push({ id, title: add.dataset.ptcProductTitle, url: add.dataset.ptcProductUrl, quantity: 1 });
    }
    save();
    render();
    notice.hidden = false;
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(() => { notice.hidden = true; }, 4500);
  });

  list.addEventListener('click', (event) => {
    const quantity = event.target.closest('[data-ptc-quantity]');
    const remove = event.target.closest('[data-ptc-remove]');
    if (quantity) {
      const item = items.find((entry) => entry.id === quantity.dataset.ptcId);
      if (item) item.quantity += Number(quantity.dataset.ptcQuantity);
      items = items.filter((entry) => entry.quantity > 0);
    } else if (remove) {
      items = items.filter((entry) => entry.id !== remove.dataset.ptcRemove);
    } else {
      return;
    }
    save();
    render();
  });

  openButton.addEventListener('click', show);
  closeButton.addEventListener('click', hide);
  overlay.addEventListener('click', hide);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) hide();
    if (event.key === 'Tab' && !panel.hidden) {
      const focusable = [...panel.querySelectorAll('button:not([disabled]), a, input, textarea')].filter((element) => !element.closest('[hidden]'));
      if (!focusable.length) return;
      if (event.shiftKey && document.activeElement === focusable[0]) {
        event.preventDefault();
        focusable.at(-1).focus();
      } else if (!event.shiftKey && document.activeElement === focusable.at(-1)) {
        event.preventDefault();
        focusable[0].focus();
      }
    }
  });

  form.addEventListener('submit', (event) => {
    if (!items.length) {
      event.preventDefault();
      return;
    }
    const lines = items.map((item) => item.quantity + ' × ' + item.title + '\n' + item.url);
    const date = widget.querySelector('#PTCQuoteDate').value;
    const notes = widget.querySelector('#PTCQuoteNotes').value.trim();
    const french = widget.dataset.ptcLocale === 'fr';
    widget.querySelector('[data-ptc-body]').value =
      (french ? 'Articles demandés en location :' : 'Rental items requested:') + '\n\n' +
      lines.join('\n\n') + '\n\n' +
      (french ? 'Date de l’événement : ' : 'Event date: ') + (date || (french ? 'Non précisée' : 'Not specified')) + '\n' +
      (french ? 'Détails : ' : 'Details: ') + (notes || (french ? 'Non précisés' : 'Not specified'));
  });

  if (widget.querySelector('[data-ptc-success]')) {
    items = [];
    save();
    render();
    show();
  } else {
    render();
  }
})();
